
<div class="login-modal">

<div class="header-bg-blue">
  <div class="row">
    <div class="col-md-10 col-10 text-left login-logo-modal">
      
        <!-- <img src='assets/img/logo-blue.svg' /> -->
        <img class="mr-auto login-logo" [src]="logo" [alt]="logo.name">

    </div>
    <div class="col-md-2 col-2 p-0">
        <button mat-dialog-action class="btnLink closeModal text-right" (click)="close()"> <fa-icon [icon]="faTimesCircle"></fa-icon></button>
    </div>
  </div>
</div>
 
<mat-dialog-content>
<div class="row">

<login  [isModal]="true" (onSuccess)="close()"> </login>







<!-- Login form -->
<!-- <div class="login-modal">

  
  
  <div class="text-center mb-3">
    <h1>{{ 'Welcome' | translate }}</h1>
  </div>

  <form [formGroup]="loginForm" class="login-container text-left" (ngSubmit)="login()">
  
    <div *ngIf="!formControls.email.valid && !formControls.password.valid && (formControls.email.errors.Invalid || formControls.password.errors.Invalid)">Username or password is incorrect !!</div>
    <div *ngIf="isSubmitted && loginForm.invalid" class="required">
      <div class="login-form-error" *ngIf="formControls.email.errors&&formControls.email.errors.InvalidCred!=null">{{ 'incorrectemailorpasswordmsg' | translate }}</div>
      <div *ngIf="formControls.hiddenValidation.errors&&formControls.hiddenValidation.errors.Default!=null">{{formControls.hiddenValidation.errors.Default}}</div>
    </div>
    <div class="form-group" [ngClass]="{ 'has-error': isSubmitted && formControls.email.errors }">
      <label>{{ 'Email' | translate }}</label>
      <input class="form-control" type="email" placeholder="{{ 'Email' | translate }}" formControlName="email">
      <div *ngIf="isSubmitted && formControls.email.errors" class="required">
        <div *ngIf="formControls.email.errors.required">{{ 'RequiredField' | translate }}</div>
        <div *ngIf="formControls.email.errors.email!=null">{{ 'InvalidEmailAddress' | translate }}</div>
        <div *ngIf="formControls.email.errors.UserNotExist!=null">{{ 'UserNotExist' | translate }}</div>
      </div>
    </div>

    <div class="form-group" [ngClass]="{ 'has-error': isSubmitted && formControls.password.errors }">
      <label>{{ 'Password' | translate }}</label>
      <input class="form-control" type="password" placeholder="{{ 'Password' | translate }}" formControlName="password">
      <div *ngIf="isSubmitted && formControls.password.errors" class="required">
        <div *ngIf="formControls.password.errors.required">{{ 'RequiredField' | translate }}</div>
      </div>
    </div>

    <div class="form-group">
      <a class="text-blue d-table mt-1" (click)="ForgotYourPassword()" >{{ 'ForgotYourPassword' | translate }}</a>
    </div>


    <div class="text-center">
      <button type="submit" class="btn login-btn">{{ 'Login' | translate }}</button>
    </div>

  </form>

  <div class="login-external">
    <p> {{ 'OrLoginThrough' | translate }} <a href="#"><img src='assets/img/facbookLogin.svg' /></a> <a href="#"><img src='assets/img/googleLogin.svg' /></a></p>
    <p class="mb-0">{{ 'IDontHaveAnAccount' | translate }}, <a href="/register" >{{ 'Register' | translate }}</a></p>
  </div>

</div>   -->
<!-- /login form -->

<!-- Forgot Password form -->
<!-- <div  *ngIf="ForgotPassword" class="login-form forgot-password">
          
  <div class="text-center mb-3">
    <h1>{{ 'RecoverPassword' | translate }}</h1>
  </div>

  <form [formGroup]="RecoverPasswordForm" class="login-container text-left" (ngSubmit)="onSubmitRecoverPassword()">
   
    <div class="form-group">
      <label for="email">Email</label>
      <input placeholder="{{ 'Pleasedefineyourregisteredemailaddress' | translate }}" type="text" class="form-control" formControlName="email" [ngClass]="{'is-invalid':RecoverPasswordForm.get('email').touched && RecoverPasswordForm.get('email').invalid}"   />
      <div *ngIf="RecoverPasswordForm.get('email').touched && RecoverPasswordForm.get('email').invalid"  class="invalid-feedback">
        <div *ngIf="RecoverPasswordForm.get('email').errors.required">Email Name is required</div>
        <div *ngIf="RecoverPasswordForm.get('email').errors.email">Email must be a valid email Address</div>
      </div>
    </div>

    <div class="text-center">
      <button type="submit" class="btn login-btn">{{ 'ResetPassword' | translate }}</button>
    </div>

    <div class="form-group text-center  mt-3">
      <a class="text-default" href="/login" >{{ 'BackToLogin' | translate }}</a>
    </div>

  </form>


</div>   -->
<!-- /Forgot Password form -->


<!-- Forgot Password form -->
<!-- <div *ngIf="ForgotPassword" class="login-form sent-successfully">
  <mat-icon>check_circle_outline</mat-icon>
  <div class="text-center mb-3">
    <h1 class="text-blue">{{ 'SentSuccessfully' | translate }}</h1>
  </div>
  <p class="text-muted">{{ 'ResetLinkhasbeensent,pleasecheckyouremailtorecoveryourforgottenpassword' | translate }}</p>
  <p>{{ 'Didntreciveemail' | translate }}, <a href="">{{ 'Reset again' | translate }}</a>? </p>
  <p><a href="/login" >{{ 'BackToLogin' | translate }}</a></p>
</div>   -->
<!-- /Forgot Password form -->



</div>
</mat-dialog-content>

</div>




